<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>配送製品詳細編集</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'EditDeliveryItem', params: {id: $route.params.id}}"
        >
          配送製品へ戻る
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="deliveryitem_headers"
          :items="deliveryitem_item"
          hide-default-footer
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <v-btn
          class="title-btn red white--text"
          @click="newItem"
        >
          配送製品明細を追加する
        </v-btn>
        <v-dialog v-model="dialog" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">配送製品明細登録</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="*配送製品明細名"
                      v-model="item.name"
                      :error-messages="validation_errors.name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          label="*発売日"
                          v-on="on"
                          v-model="item.release_date"
                          :error-messages="validation_errors.release_date"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="ja"
                        no-title
                        v-model="item.release_date"
                        @input="fromDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                    <v-select
                      label="封筒区分"
                      :items=$store.getters.envelopeTypes
                      item-text="name"
                      item-value="id"
                      v-model="item.envelopetype_id"
                      :error-messages="validation_errors.envelopetype_id"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    sm="8"
                  >
                    <v-text-field
                      label="最終更新者"
                      v-model="item.updated_by"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    sm="6"
                  >
                    <v-text-field
                      label="最終更新日"
                      v-model="item.updated_at"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    class="red white--text"
                    @click="save"
                  >
                    保存する
                  </v-btn></v-col>
                  <v-col
                    cols="12"
                    md="2"
                    sm="6"
                  >
                  <v-btn
                    class="default"
                    @click="dialog = false"
                  >キャンセル</v-btn></v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="3"
      >
        <v-text-field
          label="検索"
          dense
          v-model="search"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="50"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          :search="search"
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            color="default"
            small
            @click="editItem(item.id)"
          >
            編集
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="配送製品明細明細削除"
          message="配送製品明細を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteDeliveryItemDetail"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      loading: false,
      search: "",
      dialog: false,
      deliveryitem_headers: [
        {text: "配送製品カテゴリ", value: "deliveryitemcategory.name"},
        {text: "配送製品コード", value: "cd"},
        {text: "配送製品名", value: "name"},
      ],
      deliveryitem_item: [],
      headers: [
        {text: "名称", value: "name"},
        {text: "発売日", value: "release_date"},
        {text: "操作", value: "action", width: "130px"},
      ],
      item: {},
      validation_errors: {},
      items: [],
      options: {},
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      deleteItem: {},
    }
  },
  created() {
    this.getDeliveryItem();
    this.getDeliveryItemDetails();
  },
  methods: {
    async getDeliveryItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.deliveryitem_item = [response.data]
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'DeliveryItemList'}).catch(()=>{});
      }
    },
    async getDeliveryItemDetails() {
      this.loading = true;
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${this.$route.params.id}/details/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.items = response.data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'DeliveryItemList'}).catch(()=>{});
      }
      this.loading = false;
    },
    newItem() {
      this.item = {'new': true, 'deliveryitem_id': this.$route.params.id};
      this.validation_errors = false;
      this.dialog = true;
    },
    editItem(idx) {
      console.log(idx);
      this.item = this.items.filter((item) => item.id == idx)[0];
      console.log(this.item);
      this.validation_errors = false;
      this.dialog = true;
    },
    async save() {
      if (this.item.new) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${this.$route.params.id}/details/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {},
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.getDeliveryItemDetails();
        this.dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        const response = await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${this.$route.params.id}/details/${this.item.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {},
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        this.getDeliveryItemDetails();
        this.dialog = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.resopnse.data;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteDeliveryItemDetail() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${this.$route.params.id}/details/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getDeliveryItemDetails();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        // TODO エラーメッセージ
        console.log(error)
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    }
  }
}
</script>